import React, { Component } from 'react'
import { HashRouter, Link } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose,setDeviceConfigFailed, setMobileTVPage, setFailScreen, openSMSWidget, setOpenProfileImage } from '../../action/action'
import { connect } from 'react-redux'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setOpenDemoCamera, setGoHome, setLoader, setLoginRequired, setDNDon, setMURon } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { guestDetails, sendAnalytics } from '../../action/homeAction'
import { sendAcCommand } from '../../action/roomControlAction'
import { withTranslation } from 'react-i18next'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'

class HorizontalDoubleSmallWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetData: {}
        }
    }

    componentDidMount() {
        if (this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }

    componentDidUpdate(preProb) {
        if (preProb.widgetList !== this.props.widgetList && this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if(!room){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }

            }
            if (widget.path === "/happy") {
                if(this.props.survey.needsLogin)
                if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        return (
            <div class="widgets margin-0">
                <div class="row">
                    <div class="col col-2 flex-nowrap">
                        {this.props.widgetList.length > 0 ?
                            this.props.widgetList.map((iterator) => {
                                return (
                                    <Link
                                        exact to={iterator.path ? iterator.path : "/"}
                                        onClick={() => { this.onWidgetClick(iterator) }}
                                        class={`tile-sm thumbnails tile-container no-img-thumb ${iterator.widgetType} ${iterator.widgetMetaHtmlId?iterator.widgetMetaHtmlId:""}`}
                                        style={iterator.compImage ? {
                                            backgroundImage: `url('${iterator.compImage}')`,
                                            backgroundSize: "cover",
                                            backgroundPositionX: "center",
                                            backgroundPositionY: "top"
                                        } : {}}>
                                        <div class="thumb-text">
                                            <p class="heading" dangerouslySetInnerHTML={{__html: iterator.widgetTitle ? iterator.widgetTitle : ""}} ></p>
                                            <p className="label" dangerouslySetInnerHTML={{__html: iterator.widgetDesc ? iterator.widgetDesc : ""}} ></p>
                                        </div>
                                    </Link>
                                )
                            })
                            : ""}
                    </div>
                </div>
            </div>
        )
    }
}

HorizontalDoubleSmallWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setDNDon,
        setMURon,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        sendAcCommand,
        closeOrderPopUp,
        setHcommerceWidget,
        setMobileTVPage,
        guestDetails,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        setOpenExternalLinkInSameTab
    }
    )(withTranslation('translations')(HorizontalDoubleSmallWidget));